import i18next from 'i18next';
import { useTranslation as usei18nextTranslation } from 'react-i18next';

const NAMESPACE = 'FILES';

i18next.addResources('es', NAMESPACE, {
  FILES: 'Archivos',
  FILE_MENU: 'Menú de archivo',
  FOLDER_MENU: 'Menú de carpeta',
  FOLDER_NAME: 'Nombre de la carpeta',
  TITLE: 'Título',
  OWNER: 'Creador',
  UPDATED_AT: 'Última modificación',
  SIZE: 'Tamaño de archivo',
  ACTIONS: 'Acciones',
  EMPTY_FOLDER: 'Esta carpeta está vacía.',
  NO_MATCHES_SEARCH:
    'Ninguno de sus archivos o carpetas coincidió con esta búsqueda.',
  CREATE: 'Crear',
  DELETE: 'Eliminar',
  EDIT: 'Editar',
  CANCEL: 'Cancelar',
  CLOSE: 'Cerrar',
  ERROR_LOADING_FILES: 'Error: no se pudieron cargar los archivos',
  ERROR_LOADING_BREADCRUMBS: 'Error: no se pudieron cargar todos los datos',
  SEARCH_BAR_PLACEHOLDER: 'Buscar en esta carpeta',
  PAGE_NUMBER_CONTROLLER: 'Página\t{{pageNumber}}\t/\t{{totalPages}}',
  NOT_SUPPORTED_MESSAGE: 'No es posible previsualizar este tipo de archivos',
  NOT_SUPPORTED_MESSAGE_FOLDER: 'No es posible previsualizar una carpeta',
  ZOOM_IN: 'Aumentar zoom',
  ZOOM_OUT: 'Disminuir zoom',
  RESET_ZOOM: 'Resetear zoom',
  PREVIOUS_PAGE: 'Página anterior',
  NEXT_PAGE: 'Próxima página',
  ERROR_LOADING_IMAGE: 'Error al intentar cargar la imagen',
});

i18next.addResources('en', NAMESPACE, {
  FILES: 'Files',
  FOLDER_NAME: "Folder's name",
  TITLE: 'Title',
  OWNER: 'Creator',
  UPDATED_AT: 'Last modified',
  SIZE: 'Size',
  ACTIONS: 'Actions',
  EMPTY_FOLDER: 'This folder is empty.',
  NO_MATCHES_SEARCH: 'None of your files or folders matched this search.',
  CREATE: 'Create',
  DELETE: 'Delete',
  EDIT: 'Edit',
  CANCEL: 'Cancel',
  CLOSE: 'Close',
  ERROR_LOADING_FILES: "Error: couldn't load files",
  ERROR_LOADING_BREADCRUMBS: "Error: couldn't load all data",
  SEARCH_BAR_PLACEHOLDER: 'Search in this folder',
  PAGE_NUMBER_CONTROLLER: 'Page\t{{pageNumber}}\t/\t{{totalPages}}',
  NOT_SUPPORTED_MESSAGE: 'We cannot preview this type of file',
  NOT_SUPPORTED_MESSAGE_FOLDER: 'We cannot preview folders',
  ZOOM_IN: 'Zoom in',
  ZOOM_OUT: 'Zoom out',
  RESET_ZOOM: 'Reset zoom',
  PREVIOUS_PAGE: 'Previous page',
  NEXT_PAGE: 'Next page',
  ERROR_LOADING_IMAGE: 'There was an error loading this photo',
});

i18next.addResources('pt', NAMESPACE, {
  FILES: 'Arquivos',
  FOLDER_NAME: 'Nome da pasta',
  TITLE: 'Título',
  OWNER: 'Criador',
  UPDATED_AT: 'Última modificação',
  SIZE: 'Tamanho',
  ACTIONS: 'Ações',
  EMPTY_FOLDER: 'Esta pasta está vazia.',
  NO_MATCHES_SEARCH:
    'Nenhum dos seus arquivos ou pastas correspondeu a esta pesquisa.',
  CREATE: 'Criar',
  DELETE: 'Apagar',
  EDIT: 'Editar',
  CANCEL: 'Cancelar',
  CLOSE: 'Fechar',
  ERROR_LOADING_FILES: 'Erro: não foi possível carregar os arquivos.',
  ERROR_LOADING_BREADCRUMBS: 'Erro: não foi possível carregar todos os dados.',
  SEARCH_BAR_PLACEHOLDER: 'Pesquisar nesta pasta',
  PAGE_NUMBER_CONTROLLER: 'Página\t{{pageNumber}}\t/\t{{totalPages}}',
  NOT_SUPPORTED_MESSAGE: 'Não podemos visualizar este tipo de arquivo',
  NOT_SUPPORTED_MESSAGE_FOLDER: 'Não podemos visualizar pastas',
  ZOOM_IN: 'Mais zoom',
  ZOOM_OUT: 'Reduzir zoom',
  RESET_ZOOM: 'Redefinir zoom',
  PREVIOUS_PAGE: 'Página anterior',
  NEXT_PAGE: 'Próxima página',
  ERROR_LOADING_IMAGE: 'Erro ao tentar carregar a imagem',
});

export const useTranslation = () =>
  usei18nextTranslation([NAMESPACE, 'GENERAL']);
